import Token from '../../build/contracts/NST.sol/NinjaShrimpToken.json';
import NetworkService from './network';
import wallet from './wallet';

const TokenContractABI = {
  async getContractTokenInstance() {
    try {
      if (window.TokenInstance) {
        return window.TokenInstance;
      } else {
        const networkId = await window.web3.eth.net.getId();
        const contractAddress = NetworkService.getContractNSTAddress(networkId);
        if (!contractAddress) {
          throw new Error(`Contract not found - Check that you are in the correct network, network detected: ${NetworkService.networks[networkId]}`);
        }
        const TokenInstance = new window.web3.eth.Contract(
          Token.abi,
          contractAddress
        );
        window.TokenInstance = TokenInstance
        return window.TokenInstance;
      }
    } catch(e) {
      console.log('Error getting contract instance!');
      throw e;
    }
  },

  async totalSupply() {  
    const TokenInstance = await this.getContractTokenInstance();
    return TokenInstance.methods.totalSupply().call();
  },

  async mintRewards(_tokenId) {  
    const TokenInstance = await this.getContractTokenInstance();
    return TokenInstance.methods._mintRewards(_tokenId).send({
      from: wallet.address,
    });
  },

  async getNSTBalance() {
    const TokenInstance = await this.getContractTokenInstance();
    return TokenInstance.methods.balanceOf(wallet.address).call()

  },

  async claimRewards(_nftId) {  
    const TokenInstance = await this.getContractTokenInstance();
    return TokenInstance.methods.claimRewards(_nftId).send({
      from: wallet.address,
    });
  },

  async getTotalClaimable(address, tokenId) {  
    const TokenInstance = await this.getContractTokenInstance();
    const claimable = await TokenInstance.methods.getTotalClaimable(address, tokenId).call();
    return claimable; 
  },

  async registerForRewards(signature, tokenId, rarity) {
    const TokenInstance = await this.getContractTokenInstance();
    return TokenInstance.methods.registerForRewards(signature, tokenId, rarity).send({
      from: wallet.address,
    });
  },
  
  async rarities(nftId) {
    const TokenInstance = await this.getContractTokenInstance();
    return TokenInstance.methods.rarities(nftId).call()
  },

  async getTokenRates(){
    const TokenInstance = await this.getContractTokenInstance();
    return TokenInstance.methods.tokenRates().call()
  },

  async setTokenRates(newRates) {
    const TokenInstance = await this.getContractTokenInstance();
    return TokenInstance.methods.setTokenRates(newRates).send({from: wallet.address});
  },
  
  async bulkAdminRarityRegistration(tokenIds, rarities, tokenOwners) {
    const TokenInstance = await this.getContractTokenInstance();
    // console.log(TokenInstance)
    return TokenInstance.methods.bulkAdminRarityRegistration(tokenIds, rarities, tokenOwners).send({from: wallet.address});
  }
}
export default TokenContractABI;